module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0007#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0008#pref"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0009#pt01"
    }
  }, [_vm._v("Preliminaries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0010#ch01"
    }
  }, [_vm._v("1. The Chromatic Moment in Enlightenment Thought")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0010#ahaft0101"
    }
  }, [_c('i', [_vm._v("A Preamble on Portraiture and Language")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0010#ah0101"
    }
  }, [_c('i', [_vm._v("The Chromatic Moment")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0011#pt02"
    }
  }, [_vm._v("Moments Musicaux")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0012#ch02"
    }
  }, [_vm._v("2. The Fugal Moment: On a Few Bars in Mozart’s Quintet in C Major, K. 515")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0013#ch03"
    }
  }, [_vm._v("3. Hearing the Silence: On a Much-Theorized Moment in a Sonata by Emanuel Bach")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0014#pt03"
    }
  }, [_vm._v("The Klopstock Moment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0015#ch04"
    }
  }, [_vm._v("4. Oden von Klopstock in Musik gesetzt . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0016#ch05"
    }
  }, [_vm._v("5. Composing Klopstock: Gluck contra Bach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0016#ah0501"
    }
  }, [_c('i', [_vm._v("“A Poet among Composers”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0016#ah0502"
    }
  }, [_c('i', [_vm._v("“A Klopstock Who Worked in Tones”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0017#ch06"
    }
  }, [_vm._v("6. Beethoven: In Search of Klopstock")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0018#pt04"
    }
  }, [_vm._v("Dramma per Musica")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0019#ch07"
    }
  }, [_vm._v("7. "), _c('i', [_vm._v("Anagnorisis")]), _vm._v(": Gluck and the Theater of Recognition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0020#ch08"
    }
  }, [_vm._v("8. Cherubino’s Leap")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0021#ch09"
    }
  }, [_vm._v("9. Konstanze’s Tears")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0022#wrk_ctd"
    }
  }, [_vm._v("Works Cited")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0023#index"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikramer0024#fn_notes"
    }
  }, [_vm._v("Footnotes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e9eb770","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-kramer-0006.vue
// module id = 69
// module chunks = 0